import {queryCustomInvoiceTodo} from '@api/incubator/invoice';
import localDb from '@util/localDb';

/**
 * 代开票列表
 */
const INVOICE_TODO_LIST = 'INVOICE_TODO_LIST';
const INVOICE_TODO_LIST_LOADING = 'INVOICE_TODO_LIST_LOADING';
const INVOICE_TODO_LIST_SUCCESS = 'INVOICE_TODO_LIST_SUCCESS';
const initState = {
  dataSource: {
    list: [],
    pagination: {},
  },
};

export function getCustomInvoiceTodo(params) {
  return dispatch => {
    dispatch({
      type: INVOICE_TODO_LIST,
      data: {
        loading: true,
      },
    });
    return queryCustomInvoiceTodo(params).then(res => {
      if (res.statusCode === 200) {
        dispatch({
          type: INVOICE_TODO_LIST_SUCCESS,
          data: {
            loading: false,
          },
        });
        const data = {
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: params.limit || 15,
              current: params.current || 1,
            },
          },
        };
        localDb.set(INVOICE_TODO_LIST, data);
        return dispatch({
          type: INVOICE_TODO_LIST,
          data,
        });
      }
    });
  };
}

export function invoiceTodoList(state = initState, action) {
  switch (action.type) {
    case INVOICE_TODO_LIST:
      return { ...state, ...action.data };
    case INVOICE_TODO_LIST_SUCCESS:
      return { ...state, ...action.data };
    case INVOICE_TODO_LIST_LOADING:
      return { ...state, ...action.data };
    default:
      return localDb.get(INVOICE_TODO_LIST) || initState;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/invoice/invoice_todo_list.js